import Perfume from 'perfume.js';
import { IAnalyticsTrackerOptions } from 'perfume.js/dist/types/types';

interface Segment {
  sendTelemetryPerfEvent: (eventName: string, eventPayload: object) => void;
}

export const initPerf = (segment: Segment) => {
  return new Perfume({
    analyticsTracker: (options: IAnalyticsTrackerOptions) => {
      const { metricName, data } = options;
      switch (metricName) {
        // More info on firstInputDelay: https://web.dev/fid/
        case 'fid':
          segment.sendTelemetryPerfEvent('firstInputDelay', { duration: data });
          break;

        default:
          break;
      }
    },
  });
};
